/**
 * Link universale del ticket (`/t/<numero>`, vedi `pages/TicketLinkPage.tsx`) e
 * testo per WhatsApp. Il link non porta token: chi lo apre accede con la propria
 * sessione e vede il ticket solo se rientra nel suo perimetro.
 */
export interface ShareableTicket {
  _id: string;
  ticketNumber?: string | null;
  subject?: string | null;
}

export const ticketShareUrl = (origin: string, t: ShareableTicket): string =>
  `${String(origin || '').replace(/\/+$/, '')}/t/${encodeURIComponent(t.ticketNumber || t._id)}`;

export const ticketShareText = (origin: string, t: ShareableTicket): string =>
  `Ticket #${t.ticketNumber || t._id} – ${t.subject || ''}`.trimEnd() + `\n${ticketShareUrl(origin, t)}`;

export const whatsappShareHref = (origin: string, t: ShareableTicket): string =>
  `https://wa.me/?text=${encodeURIComponent(ticketShareText(origin, t))}`;

/** Copia negli appunti: Clipboard API, poi execCommand come ripiego. false se nessuno dei due riesce. */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // contesto non sicuro o permesso negato: si prova il ripiego
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = typeof document.execCommand === 'function' && document.execCommand('copy');
    document.body.removeChild(ta);
    return Boolean(ok);
  } catch {
    return false;
  }
};
